import {
  apiSource,
  apiUrl,
  assetOrigin,
  buildClassifiedsApiHost,
} from "../config/apiSource";

export const REGEXES = {
  password: /^[a-zA-Z0-9!@#$%^&*(),.?":{}|<>]{6,}$/,
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  phone:
    /^(?:(?:\+7|7|8)[\s-]?(?:\(?\d{3}\)?)[\s-]?\d{3}[\s-]?\d{2}[\s-]?\d{2}|(?:\(?\d{3}\)?)[\s-]?\d{3}[\s-]?\d{2}[\s-]?\d{2})$/,
};

const { host, origin, pathname } = window.location;

export const isProd = host === "husamhelper.ru";
export const isTestStand = host === "stage1.husamhelper.ru";
export const isLocalHost = /^(localhost|127\.0\.0\.1)(:\d+)?$/.test(host);

export const isLanding = pathname.includes("landing");
export const isDune = origin.includes("://dune.");

export const baseHost = assetOrigin;
export const classifiedsHost = buildClassifiedsApiHost(
  apiSource,
  baseHost,
  process.env.REACT_APP_CLASSIFIEDS_API_URL,
);

export const API_ENDPOINTS = {
  flatsTable: "https://mgmdk.ru/bot/api/realty/index.php",

  // --- OLD (жилая) ---
  housings: apiUrl("/api/v1/old/housings?getHousings"),
  installmentPlanTypes: apiUrl("/api/v1/old/housings?getInstallmentPlanTypes"),
  housingPricesByFirstPayment: apiUrl("/api/v1/old/prices?byFirstPayment"),
  housingPricesByPeriod: apiUrl("/api/v1/old/prices?byPeriod"),

  // --- OLD-COMMERCE (коммерческая) ---
  commerceHousings: apiUrl("/api/v1/old-commerce/housings?getHousings"),
  commerceInstallmentPlanTypes: apiUrl(
    "/api/v1/old-commerce/housings?getInstallmentPlanTypes",
  ),
  commercePricesByFirstPayment: apiUrl(
    "/api/v1/old-commerce/prices?byFirstPayment",
  ),
  commercePricesByPeriod: apiUrl("/api/v1/old-commerce/prices?byPeriod"),

  // --- AUTH & USER ---
  userSignIn: apiUrl("/api/v1/auth/login"),
  userSignUp: apiUrl("/api/v1/auth/register"),
  getUserInfo: apiUrl("/api/v1/user/profile"),
  getUserInfoById: apiUrl("/api/v1/user/"),
  updateProfile: apiUrl("/api/v1/user"),

  // --- FILES ---
  uploadFiles: apiUrl("/api/v1/file/upload"),
  deleteUploadedFiles: apiUrl("/api/v1/file/delete"),
  uploadNewFiles: apiUrl("/api/v1/assignment-image/"),
  deleteFiles: apiUrl("/api/v1/assignment-image/bulk/"),

  // --- AUTH EXTRA ---
  verifyEmail: apiUrl("/api/v1/auth/verify/email/"),
  resetPassword: apiUrl("/api/v1/auth/reset-password"),

  // --- PAYMENT & SUBSCRIPTION ---
  payment: apiUrl("/api/v1/payment/widget-url"),
  subscriptionPlans: apiUrl("/api/v1/subscription-plan"),

  // --- ASSIGNMENTS ---
  contractAssignments: apiUrl("/api/v1/assignment"),
  contractAssignmentsByUser: apiUrl("/api/v1/assignment/by-user/"),

  // --- SHARING ---
  getSharedData: apiUrl("/api/v1/shared-calc/"),
  getSharingDataId: apiUrl("/api/v1/shared-calc"),

  // --- AI & CONTACTS ---
  aiSearch: apiUrl("/api/v1/housing-search"),
  contacts: apiUrl("/api/v1/user/socials"),

  clientsBase: apiUrl("/api/v1/client/all"),
  client: apiUrl("/api/v1/client"),
  clientDeals: apiUrl("/api/v1/client/"),
  clientDeal: apiUrl("/api/v1/client/deal"),
  clientDealComment: apiUrl("/api/v1/comment"),
  clientDealAttachment: apiUrl("/api/v1/attachment"),
  dealAttachments: apiUrl("/api/v1/deal"),
  dealStatuses: apiUrl("/api/v1/deal/statuses"),

  // ---- Users ----
  users: apiUrl("/api/v1/admin/users"),
  subscribedUsers: apiUrl("/api/v1/admin/users/subscribed"),
  deleteUser: apiUrl("/api/v1/admin/users"),
  resetUserPassword: apiUrl("/api/v1/admin/users/reset-password"),
  createUserSubscription: (id: number | string) =>
    apiUrl(`/api/v1/admin/users/${id}/subscription`),
  updateUser: (id: number | string) => apiUrl(`/api/v1/admin/users/${id}`),
  managers: apiUrl("/api/v1/admin/managers"),
  manager: (id: number | string) => apiUrl(`/api/v1/admin/managers/${id}`),
  metrikaAnalytics: apiUrl("/api/v1/admin/analytics/metrika"),
  metrikaAnalyticsPeriodLimits: apiUrl(
    "/api/v1/admin/analytics/metrika/period-limits",
  ),
  metrikaAnalyticsRefresh: apiUrl("/api/v1/admin/analytics/metrika/refresh"),
  metrikaAnalyticsRefreshStatus: (refreshId: string) =>
    apiUrl(
      `/api/v1/admin/analytics/metrika/refresh/${encodeURIComponent(refreshId)}`,
    ),

  classifiedsListings: `${classifiedsHost}/v1/listings`,
  classifiedsListingConstraints: `${classifiedsHost}/v1/listings/constraints`,
  classifiedsCreatePermission: `${classifiedsHost}/v1/listings/create-permission`,
  classifiedsListingsMap: `${classifiedsHost}/v1/listings/map`,
  classifiedsGeocode: `${classifiedsHost}/v1/listings/geocode`,
  classifiedsMyListings: `${classifiedsHost}/v1/listings/mine`,
  classifiedsListing: (type: string, id: number | string) =>
    `${classifiedsHost}/v1/listings/${type}/${id}`,
  classifiedsListingShare: (type: string, id: number | string) =>
    `${classifiedsHost}/v1/listings/${type}/${id}/shares`,
  classifiedsSharedListing: (token: string) =>
    `${classifiedsHost}/v1/listing-shares/${encodeURIComponent(token)}`,
  classifiedsModerationListings: `${classifiedsHost}/v1/admin/listings/moderation`,
  classifiedsModerationStream: `${classifiedsHost}/v1/admin/listings/moderation/stream`,
  classifiedsErrorEvents: `${classifiedsHost}/v1/admin/error-events`,
  classifiedsErrorEvent: (id: number | string) =>
    `${classifiedsHost}/v1/admin/error-events/${encodeURIComponent(String(id))}`,
  classifiedsErrorEventsExport: `${classifiedsHost}/v1/admin/error-events/export`,
  classifiedsErrorEventsReviewStatus: `${classifiedsHost}/v1/admin/error-events/review-status`,
  classifiedsApproveModeration: (type: string, id: number | string) =>
    `${classifiedsHost}/v1/admin/listings/${type}/${id}/moderation/approve`,
  classifiedsRejectModeration: (type: string, id: number | string) =>
    `${classifiedsHost}/v1/admin/listings/${type}/${id}/moderation/reject`,
  classifiedsListingCreationWhitelist: `${classifiedsHost}/v1/admin/listing-creation-whitelist`,
  classifiedsListingCreationWhitelistEntry: (email: string) =>
    `${classifiedsHost}/v1/admin/listing-creation-whitelist/${encodeURIComponent(email)}`,
  classifiedsTaxonomy: `${classifiedsHost}/v1/listings/taxonomy`,
  classifiedsDraft: (ownerId: number | string) =>
    `${classifiedsHost}/v1/listings/drafts/${ownerId}`,
  classifiedsAuthorListings: (id: number | string) =>
    `${classifiedsHost}/v1/authors/${id}/listings`,
  classifiedsUserListings: (id: number | string) =>
    `${classifiedsHost}/v1/users/${id}/listings`,
};

export const INSTALLMENT_PLANS_LIB = {
  full: {
    name: "full",
    label: "полная стоимость",
  },
  without: {
    name: "without",
    label: "без взноса",
  },
};

export const IMAGE_SIDES = {
  width: "width",
  height: "height",
};

export const APP_MODES = {
  housings: {
    name: "housings",
    id: 1,
    alias: "/housings",
  },
  contractAssignments: {
    name: "contractAssignments",
    id: 2,
    alias: "contract-assignment",
  },
};

export const ROUTES = {
  housings: "/housings",
  contractAssignment: "/contract-assignment",
  classifieds: "/classifieds",
  classifiedsMy: "/classifieds/my",
  classifiedsFavorites: "/classifieds/favorites",
  classifiedsModeration: "/classifieds/moderation",
  cooperationModels: "/cooperation-models",
  payment: "/payment",
  aiSearch: "/ai-search",
  clientBase: "/client-base",
};

export const FEATURE_KEYS = {
  LIMIT: "userHasAssignmentDefaultLimit",
  EXPIRES: "userHasAssignmentDefaultExpiresAt",
  PRIVATE: "userAllowAssignmentChangePrivate",
} as const;

export const SUBSCRIPTION_PLANS = {
  default: {
    id: 7676178440000001,
    name: "default",
    displayName: "Ограниченный доступ",
    description:
      "Базовый уровень доступа с ограниченным функционалом. Подходит для кратковременного использования и ознакомления с возможностями сервиса.",
    features: [],
    restrictions: [FEATURE_KEYS.LIMIT, FEATURE_KEYS.EXPIRES],
  },
  personal: {
    name: "personal",
    displayName: "Персональная подписка",
    description:
      "Полный доступ к сервису без ограничений. Идеально для активных пользователей, которым важна гибкость и расширенные возможности.",
    features: [FEATURE_KEYS.PRIVATE],
    restrictions: [],
  },
};

export const CLIENT_DEAL_STATUSES = [
  { id: 7590845760000001, code: "contact", name: "Контакт" },
  { id: 7590845760000002, code: "need", name: "Выявление потребности" },
  { id: 7590845760000003, code: "presentation", name: "Презентация продукта" },
  { id: 7590845760000004, code: "selection", name: "Подбор" },
  { id: 7590845760000005, code: "objections", name: "Возражения" },
  { id: 7590845760000006, code: "closing", name: "Закрытие" },
  { id: 7590845760000007, code: "waiting_object", name: "Ждём объект" },
  { id: 7590845760000008, code: "waiting_money", name: "Ждём деньги" },
  { id: 7590845760000009, code: "closed_success", name: "Успех" },
  { id: 7590845760000010, code: "failed", name: "Провал" },
];
